import type { NextPage } from 'next';
import withEmailVerification from './withEmailVerification';
import withSmsMfaEnrollment from './withSmsMfaEnrollment';

// Combine both HOCs to create a complete authentication flow
// 1. Email verification
// 2. SMS 2FA enrollment
// 3. REPLACE in all pages using only email verification completed by this HOC
const withCompleteAuthentication = <P extends object>(Component: NextPage<P>): NextPage<P> => {
    // Apply HOCs in reverse order (innermost first)
    // This ensures email verification happens before 2FA enrollment
    return withSmsMfaEnrollment(withEmailVerification(Component));
};

export default withCompleteAuthentication;
